import React, { useEffect, useState } from "react";

import { useGetPastWeekSales } from "../../../api/SalesPerson.hooks";
import InformationModal from "../../InformationModal";
import Loader from "../../Loader";
import { Bar } from "react-chartjs-2";
import { Container } from "reactstrap";
import { utils } from "../../../utils/utils";

import { Chart as ChartJS, Tooltip, Legend, Filler, Title } from "chart.js";

ChartJS.register(Tooltip, Legend, Filler, Title);

const options = {
  ...utils.chartOptions,
  scales: {
    y: {
      ticks: {
        callback: (value) => `${value}`,
      },
    },
  },
  plugins: {
    tooltip: {
      callbacks: {
        label: (tooltipItem) =>
          ` ${tooltipItem.formattedValue} - ${
            tooltipItem.formattedValue === 1 ? "sale" : "sales"
          }`,
      },
    },
  },
};

const PastWeeksSales = () => {
  const {
    data: pastWeeksSales,
    error: pastWeeksSalesErr,
    isLoading: isLoadingPastWeeksSales,
    get: getPastWeeksSales,
  } = useGetPastWeekSales();

  const [informationModal, setInformationModal] = useState({
    isOpen: false,
    title: "",
    body: "",
  });

  const [data, setData] = useState({ labels: [], datasets: [] });

  useEffect(() => {
    getPastWeeksSales();
  }, [getPastWeeksSales]);

  useEffect(() => {
    if (pastWeeksSales) {
      const data = {
        labels: [1, 2, 3, 4, 5, 6],
        datasets: [
          {
            label: "Past 6 Weeks Sales",
            data: [0, 0, 0, 0, 0, 0, 0],
            backgroundColor: "rgba(155,204, 244, 0.7)",
          },
        ],
      };
      if (pastWeeksSales.rows && pastWeeksSales.rows.length) {
        data.labels = pastWeeksSales.rows.map(
          (sale) => `${sale.startWeek} - ${sale.endWeek}`
        );
        data.datasets[0].data = pastWeeksSales.rows.map((sale) => sale.total);
      }
      setData(data);
    }
  }, [pastWeeksSales]);

  useEffect(() => {
    if (pastWeeksSalesErr) {
      return setInformationModal({
        isOpen: true,
        title: "Error",
        body: "There was an error with your request.",
      });
    }
  }, [pastWeeksSalesErr]);

  return (
    <div className="h-100">
      {isLoadingPastWeeksSales ? (
        <Container className="my-7">
          <Loader size="sm"/>
        </Container>
      ) : (
        <Bar options={options} data={data} />
      )}
      {informationModal.isOpen ? (
        <InformationModal
          {...informationModal}
          onClose={() =>
            informationModal.onClose
              ? informationModal.onClose()
              : setInformationModal({ isOpen: false })
          }
        />
      ) : null}
    </div>
  );
};

export default PastWeeksSales;
